'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import ImageWithFallback from '../ui/image/image-with-fallback';
import { useReplaceClickId } from '@/src/hooks/use-clickid';
import { RecourseLoader } from '../recourse/recourse-loader/recourse-loader';
import { Logo } from '../ui/icons/icons';
import { SkeletonLoader } from './skeleton-loader/skeleton-loader';

interface RecourseRedirectorProps {
  bankName: string;
  logoPath?: string;
  forwardLink: string;
  forwardingWaitTime?: number;
  customRedirect?: (url: string) => void;
}

export const RecourseRedirector: React.FC<RecourseRedirectorProps> = ({
  bankName,
  logoPath,
  forwardLink,
  forwardingWaitTime = 3,
  customRedirect,
}) => {
  const router = useRouter();
  const safeLink = useReplaceClickId(forwardLink);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (customRedirect) {
        customRedirect(safeLink);
      } else {
        router.replace(safeLink);
      }
    }, forwardingWaitTime * 1000);

    const cancel = () => clearTimeout(timer);
    window.addEventListener('popstate', cancel);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('popstate', cancel);
    };
  }, [safeLink, forwardingWaitTime, customRedirect, router]);

  return (
    <div className="mx-auto mt-4 flex max-w-[436px] flex-col items-center justify-center gap-5 text-center md:mt-[101px]">
      {/* {logoPath && <Image src={logoPath} width={80} height={80} alt={bankName} />} */}
      <>
        <div className="flex w-full flex-col items-center gap-5">
          <Logo className={'logo'} width={198} height={36} data-testid="logo" />
          <ImageWithFallback src="/assets/recourse/redirect-ok.gif" width={50} height={50} alt={'hangikredi'} />
          {/* <SkeletonLoader type="image" className="h-[33px] w-[195px]" /> */}
          <ImageWithFallback src={logoPath} width={195} height={33} alt={'hangikredi'} />
        </div>
        {/* <div className="mt-[93px] flex w-full flex-col items-center gap-3 px-[34px] md:mt-[100px]">
          <SkeletonLoader className="h-6 w-[149px]" />
          <SkeletonLoader className="h-[72px] w-[292px]" />
        </div> */}
      </>
      <div className="flex items-center gap-2">
        <ImageWithFallback src="/assets/recourse/Secure.svg" width={15} height={17} alt="hangikredi" />
        <span className="text-sm font-semibold text-gray-500">Güvenli Başvuru</span>
      </div>
      <p className="font-semibold leading-6 text-gray-800">
        Başvurunuzu tamamlayabilmeniz için {bankName} güvenli web sitesine yönlendiriliyorsunuz.
      </p>
      <div className="w-full border-t border-gray-300 pt-5">
        <p className="text-xs font-semibold text-gray-800">
          {bankName} güvenli websitesi yüklenmemesi durumunda{' '}
          <a href={safeLink} target="_blank" rel="noreferrer" className="text-purple-700">
            buraya tıklayınız.
          </a>
        </p>
      </div>
      {/* <RecourseLoader /> */}
    </div>
  );
};
